import {ApolloClient} from "apollo-client";
import {NormalizedCacheObject} from "apollo-cache-inmemory";
import {KatalHelper} from "../pages/metrics/KatalHelper";
import { v4 as uuid4 } from "uuid";

export async function processGQLQuery<Type>(client: ApolloClient<NormalizedCacheObject>, query: any, queryVariables: any, katalMetricsHelper: KatalHelper, queryName: string, methodName: string): Promise<Type>  {

    const uuid:string = uuid4();
    katalMetricsHelper.startLatencyTimer(queryName, uuid);
    katalMetricsHelper.logInfo(`calling the query api ${queryName} within method ${methodName} with queryVariable ${JSON.stringify(queryVariables)}`);
    const data: Type = await
        new Promise<Type>((resolve, reject) => {
            client.query({
                fetchPolicy: "no-cache",
                query: query,
                variables: queryVariables
            }).then((data) => {
                return resolve(data?.data);
            })
            .catch((error) => {
                // Todo based on different type of errors emit different metrics like AccessDenied, NetworkError
                katalMetricsHelper.emitCountMetrics("Error:" + queryName, methodName, 1);
                katalMetricsHelper.logError(`Error encountered while calling the query api ${queryName} within method ${methodName}: ` + JSON.stringify(error));
                katalMetricsHelper.removeAPIFromOperationMap(uuid); // not emitting latency metric in case of error
                return reject(error);
            })
        });
    katalMetricsHelper.emitCountMetrics("SUCCESS:" + queryName, methodName, 1);
    katalMetricsHelper.emitLatencyMetrics(methodName, uuid);
    katalMetricsHelper.logInfo(`Successfully executed the query for api ${queryName} within method ${methodName} returned data ${JSON.stringify(data)}`);
    return data;

}

export async function processGQLMutation<Type>(client: ApolloClient<NormalizedCacheObject>, mutation: any, mutationVariables: any, katalMetrcisHelper: KatalHelper, mutationName: string, methodName: string): Promise<Type> {

    const uuid:string = uuid4();
    katalMetrcisHelper.startLatencyTimer(mutationName, uuid);
    katalMetrcisHelper.logInfo(`calling the mutation api ${mutationName} within method ${methodName} with queryVariable ${JSON.stringify(mutationVariables)}`);
    const data: Type = await
        new Promise<Type>((resolve, reject) => {
            client.mutate({
                mutation: mutation,
                fetchPolicy: "no-cache",
                variables: mutationVariables
            }).catch((error) => {
                katalMetrcisHelper.emitCountMetrics("Error:" + mutationName, methodName, 1);
                katalMetrcisHelper.logError(`Error encountered while calling the mutation api ${mutationName} within method ${methodName}` + error);
                katalMetrcisHelper.removeAPIFromOperationMap(uuid); // not emitting latency metric in case of error
                return reject(error);
            })
        });
    katalMetrcisHelper.emitCountMetrics("SUCCESS:" + mutationName, methodName, 1);
    katalMetrcisHelper.emitLatencyMetrics(methodName, uuid);
    katalMetrcisHelper.logInfo(`Successfully executed the mutation for api ${mutationName} within method ${methodName} returned data ${JSON.stringify(data)}`);
    return data;
}



